const removeGiftWrappingItem = {
  init() {
    // this.flg = JSON.parse(document.querySelector('[data-wl-flg-check]').textContent);
    // this.giftItemFlg = this.flg.gift_item;
    // this.unGiftItemFlg = this.flg.no_gift_item;
    // if (this.giftItemFlg == true && this.unGiftItemFlg == false) {
    //   this.fetchEvt();
    // }
    this.removeCartItems();
  },
  async removeCartItems() {
    const cartItems = await this.getCartItemsFetch();
    const giftItems = cartItems.items.filter(
      (item) => item.properties["Wrapping No"]
    );
    // console.log(cartItems.item_count, giftItems.length)
    if (cartItems.item_count == giftItems.length) {
      this.fetchEvt();
      return;
    }
    for (let giftItem of giftItems) {
      for (let key in giftItem.properties) {
        if (/__対象商品/.test(key)) {
          const targetItem = cartItems.items.find(
            (item) => item.key == giftItem.properties[key]
          );
          if (!targetItem) {
            continue;
          }
          const giftQty = parseInt(
            giftItem.properties[`__数量_${key.replace("__対象商品key_", "")}`]
          );
          const itemQty = targetItem.quantity;
          const wrappingType = cartItems.attributes["ラッピング設定"];

          if (giftQty > itemQty) {
            // console.log('ギフトが多い')
            // document.querySelector('.goToCheckout').classList.add('hidden')
          } else if (
            (giftQty < itemQty && wrappingType == "一括") ||
            wrappingType == "個別"
          ) {
            // console.log('ギフトが少ない')
            // document.querySelector('.goToCheckout').classList.add('hidden')
          } else {
            // document.querySelector('.goToCheckout').classList.remove('hidden')
          }
        }
      }
    }
  },
  getCartItemsFetch() {
    return new Promise((resolve, reject) => {
      fetch("/cart.js")
        .then((res) => res.json())
        .then((res) => {
          resolve(res);
        })
        .catch((error) => console.log(error));
    });
  },
  fetchEvt() {
    fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        section_url: location.href,
        sections: [
          document.getElementById("main-cart-items")?.dataset.id,
          document.getElementById("main-cart-footer")?.dataset.id,
          document.getElementById("wl-gift-wrapping")?.dataset.id,
          document.getElementById("wl-cart-delivery-date")?.dataset.id,
        ],
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        for (let id in res.sections) {
          const html = new DOMParser().parseFromString(
            res.sections[id],
            "text/html"
          );
          // console.log(id)
          document
            .querySelector(`[data-id="${id}"]`)
            .closest(".shopify-section").innerHTML = html
            .querySelector(`[data-id="${id}"]`)
            .closest(".shopify-section").innerHTML;
        }
      });
  },
};
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(
        this.dataset.quantityVariantId,
        0,
        false,
        this.dataset.index,
        this.dataset.deleteEngravingCostKey,
        this.dataset.deleteEngravingCostQuantity,
        this.dataset.deleteTargetQuantity
      );
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    if (event.target.closest("quantity-input").dataset.updateEngravingCostKey) {
      this.updateQuantity(
        event.target.dataset.quantityVariantId,
        event.target.value,
        document.activeElement.getAttribute("name"),
        event.target.dataset.index,
        event.target.closest("quantity-input").dataset.updateEngravingCostKey,
        event.target.closest("quantity-input").dataset
          .updateEngravingCostQuantity,
        event.target.closest("quantity-input").dataset.updateTargetQuantity
      );
    } else {
      this.updateQuantity(
        event.target.dataset.quantityVariantId,
        event.target.value,
        document.activeElement.getAttribute("name"),
        event.target.dataset.index
      );
    }
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "wl-gift-wrapping",
        section: document.getElementById("wl-gift-wrapping").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".goToCheckout",
      },
      // {
      //   id: 'wl-cart-delivery-date',
      //   section: document.getElementById('wl-cart-delivery-date').dataset.id,
      //   selector: '.js-contents',
      // },
    ];
  }
  setLoading(flg) {
    if (flg) {
      document.querySelector(".loader")?.classList.remove("hidden");
    } else {
      document.querySelector(".loader")?.classList.add("hidden");
    }
  }
  getShippingDateSection() {
    return new Promise((resolve) => {
      const sectionId = document.getElementById("wl-cart-delivery-date").dataset
        .id;
      fetch(
        location.pathname +
          `?sections[]=${sectionId}&sections_url=${location.pathname}`
      )
        .then((res) => res.json())
        .then((res) => {
          const shippingSection = this.getSectionInnerHTML(
            res[sectionId],
            ".wl-delivery-date-section",
            true
          );
          document
            .querySelector("#wl-cart-delivery-date")
            .closest(".wl-delivery-date-section").outerHTML = shippingSection
            .querySelector("#wl-cart-delivery-date")
            .closest(".wl-delivery-date-section").outerHTML;
          const src = shippingSection.querySelector("#wl-cart-delivery-date")
            .dataset.src;
          fetch(src)
            .then((response) => response.text())
            .then((text) => {
              const script = document.createElement("script");
              script.type = "text/javascript";
              script.text = text;
              document.querySelector("#cart-item-flg").innerHTML = "";
              document.querySelector("#cart-item-flg").append(script);
            });
          resolve(true);
        });
    });
  }
  updateMICost() {
    const removeElm = document.querySelector("[data-remove-mi-cost]");
    const updateElm = document.querySelector("[data-update-mi-cost]");
    const removeJson = JSON.parse(removeElm.textContent);
    const updateJson = JSON.parse(updateElm.textContent);
    const target = Object.assign(removeJson, updateJson);
    const sections = document.querySelector("cart-items");
    const update = {
      updates: target,
      sections: sections
        .getSectionsToRender()
        .map((section) => section.section),
    };
    if (Object.keys(target).length > 0) {
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(update),
      })
        .then((res) => res.json())
        .then(async (res) => {
          if (res.item_count == 0) {
            location.reload(true);
            return;
          }
          // const shipSection = await this.getShippingDateSection()
          sections.getSectionsToRender().forEach((section) => {
            if (document.getElementById(section.id)) {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id);
              elementToReplace.innerHTML = sections.getSectionInnerHTML(
                res.sections[section.section],
                section.selector
              );
            }
          });
          this.setLoading(false);
        });
    } else {
      this.setLoading(false);
    }
  }
  updateQuantity(
    id,
    quantity,
    name,
    line,
    engravingCost = false,
    engravingCostQuantity = false,
    targetQuantity = false
  ) {
    this.cart = document.querySelector("cart-drawer");

    this.enableLoading(line);
    const json = {
      updates: {
        [id]: parseInt(quantity),
      },
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    };
    if (engravingCost !== false) {
      // console.log(parseInt(engravingCostQuantity), quantity , parseInt(targetQuantity))
      json["updates"][engravingCost] =
        parseInt(engravingCostQuantity) +
        (parseInt(quantity) - parseInt(targetQuantity));
    }
    // console.log(json)
    const body = JSON.stringify(json);
    this.setLoading(true);
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then(async (state) => {
        const parsedState = JSON.parse(state);

        removeGiftWrappingItem.init();

        if (parsedState.item_count === 0) {
          if (window.cartType === "drawer") {
            this.cart?.renderContents(parsedState);
          } else {
            location.reload(true);
          }

          return;
        }

        // console.log()
        const engravingConst = parsedState.items.filter((item) =>
          /加工代/.test(item.handle)
        );

        // console.log('parsedState.item_count: ', parsedState.item_count, 'engravingConst.length: ', engravingConst.length)
        // const shipSection = await this.getShippingDateSection()

        if (parsedState.item_count === engravingConst.length) {
          this.getSectionsToRender().forEach((section) => {
            if (
              document.getElementById(section.id) &&
              section.id === "main-cart-footer"
            ) {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id);
              const renderHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
              elementToReplace.classList.add("hidden");
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          });

          this.cart?.init();

          // this.updateMICost()
          // const shipSection = await this.getShippingDateSection()
          return;
        } else {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) ||
            document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll(".cart-item");

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute("value");
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle("is-empty", parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector("cart-drawer");
          const cartFooter = document.getElementById("main-cart-footer");

          if (cartFooter)
            cartFooter.classList.toggle(
              "is-empty",
              parsedState.item_count === 0
            );
          if (cartDrawerWrapper)
            cartDrawerWrapper.classList.toggle(
              "is-empty",
              parsedState.item_count === 0
            );

          this.getSectionsToRender().forEach((section) => {
            if (document.getElementById(section.id)) {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id);

              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          });

          this.cart?.init();

          // this.updateMICost()
          const updatedValue = parsedState.items[line - 1]
            ? parsedState.items[line - 1].quantity
            : undefined;
          let message = "";
          if (
            items.length === parsedState.items.length &&
            updatedValue !== parseInt(quantityElement.value)
          ) {
            if (typeof updatedValue === "undefined") {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace(
                "[quantity]",
                updatedValue
              );
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) ||
            document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(
                  cartDrawerWrapper,
                  lineItem.querySelector(`[name="${name}"]`)
                )
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(
              cartDrawerWrapper.querySelector(".drawer__inner-empty"),
              cartDrawerWrapper.querySelector("a")
            );
          } else if (
            document.querySelector(".cart-item") &&
            cartDrawerWrapper
          ) {
            trapFocus(
              cartDrawerWrapper,
              document.querySelector(".cart-item__name")
            );
          }
          publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
          this.setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        this.setLoading(false);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector, targetElm = false) {
    if (targetElm === true) {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector);
    }
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

const shippingDateSettingConfirm = {
  init() {
    const links = document.querySelectorAll(
      "a:not(.wl-remove-btn):not(.cart-type-drawer):not(.cart-type-notification)"
    );
    for (let link of links) {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        if (document.body.dataset.updateFlg === "true") {
          if (
            confirm(
              "お届け日時指定内容は一度リセットされます。カートページに戻られましたら再度ご設定ください。"
            )
          ) {
            if (e.target.tagName === "A") {
              location.href = e.target.getAttribute("href");
            } else {
              location.href = e.target.closest("a").getAttribute("href");
            }
          } else {
            return false;
          }
        } else {
          if (e.target.tagName === "A") {
            location.href = e.target.getAttribute("href");
          } else {
            location.href = e.target.closest("a").getAttribute("href");
          }
        }
      });
    }
  },
};
// document.addEventListener("DOMContentLoaded", () => {
//   shippingDateSettingConfirm.init();
// });
